<template>
  <div class="otherInfo">
    <p>
      其他信息
      <a-icon
        :type="showOtherInfo ? 'down-circle' : 'right-circle'"
        style="font-size: 20px; margin-left: 10px"
        @click="showHideOtherInfo"
      />
    </p>
    <div class="botInfo" v-show="showOtherInfo">
      <a-row>
        <a-col :span="6">
          <p>商铺类型</p>
          <p>
            {{ HousesData.shopTypeId | filterDict(shopTypeOpts) }}
          </p>
        </a-col>
        <a-col :span="6">
          <p>商铺性质</p>
          <p>
            {{ HousesData.shopNatureId | filterDict(shopNatureOpts) }}
          </p>
        </a-col>
        <a-col :span="6">
          <p>历史经营</p>
          <p v-if="HousesData.industryCategoryName == null">--</p>
          <p v-else>
            {{ HousesData.industryCategoryName + '-' + HousesData.industrySubclassName }}
          </p>
        </a-col>
        <a-col :span="6">
          <p>产权性质</p>
          <p>
            {{ HousesData.propertyNatureId | filterDict(proppertyNatureOpts) }}
          </p>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="6">
          <p>建筑面积</p>
          <p>{{ HousesData.grossFloorArea }}m²</p>
        </a-col>
        <a-col :span="6">
          <p>实用面积</p>
          <p>{{ HousesData.saleableArea }}m²</p>
        </a-col>
        <a-col :span="6">
          <p>面宽，层高，进深</p>
          <p>{{ HousesData.houseWide }}m,{{ HousesData.houseHigh }}m,{{ HousesData.houseLong }}m</p>
        </a-col>
        <a-col :span="6">
          <p>可否餐饮</p>
          <p>
            {{ HousesData.isCatering | filterDict(weatherOpts) }}
          </p>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="6">
          <p>是否临街</p>
          <p>
            {{ HousesData.isFrontage | filterDict(weatherOpts) }}
          </p>
        </a-col>
        <a-col :span="6">
          <p>支付方式</p>
          <p>{{ HousesData.paymentMethod | fiflterYF }}</p>
        </a-col>
        <a-col :span="6">
          <p>转让费</p>
          <p>{{ HousesData.transferFee }}万元</p>
        </a-col>
        <a-col :span="6">
          <p>佣金</p>
          <p>{{ HousesData.houseBrokerage }}月</p>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="6">
          <p>递增</p>
          <p>{{ HousesData.progressiveIncrease }}</p>
        </a-col>
        <a-col :span="6">
          <p>租金</p>
          <p>
            {{ HousesData.rentFee }}元/月,{{ HousesData.rentFeeCentiare }}元/m²/月,
            {{ ((HousesData.rentFeeCentiare || 0) / 30).toFixed(2) }}元/m²/天
          </p>
        </a-col>
        <a-col :span="6">
          <p>相关物业</p>
          <p>
            物业费{{ HousesData.propertyFee }}元，电费{{ HousesData.electricityFee }}元/度，水费{{
              HousesData.waterFee
            }}元/吨
          </p>
        </a-col>
        <a-col :span="6">
          <p>户数</p>
          <p>
            {{ (HousesData.communityVo && HousesData.communityVo.cellNumber) || 0 }}
          </p>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="6">
          <p>建成年代</p>
          <p>{{ (HousesData.communityVo && HousesData.communityVo.constructionTime) || '暂无' }}</p>
        </a-col>
      </a-row>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      showOtherInfo: false, // 是否显示其他信息
      HousesData: {}, // 房源详情
      shopTypeOpts: [],
      proppertyNatureOpts: [],
      weatherOpts: [],
      shopNatureOpts: []
    }
  },
  props: {
    housesDatas: {
      type: Object,
      default: () => {}
    }
  },
  watch: {
    housesDatas: {
      handler: function (newVal, oldVal) {
        this.HousesData = newVal
      }
    },
    immediate: true,
    deep: true
  },
  mounted () {
    this.getDicts('property_nature').then((response) => {
      this.proppertyNatureOpts = response.data
    })
    this.getDicts('sys_yes_no').then((response) => {
      this.weatherOpts = response.data
    })
    this.getDicts('shop_type').then((response) => {
      this.shopTypeOpts = response.data
    })
    this.getDicts('shop_nature').then((response) => {
      this.shopNatureOpts = response.data
    })
  },
  filters: {
    fiflterYF (val) {
      if (!val) return
      return val.replace('Y', '押').replace('F', '付')
    },
    filterDict (val, opts) {
      if (!val) return
      for (const d of opts) {
        if (d.dictValue == val) {
          return d.dictLabel
        }
      }
    }
  },
  methods: {
    showHideOtherInfo () {
      this.showOtherInfo = !this.showOtherInfo
    }
  }
}
</script>
<style lang="less" scoped>
.otherInfo {
  border-top: 2px solid #f2f6fc;

  & > p {
    font-size: 14px;
    font-weight: bold;
    color: black;
    padding-top: 20px;
  }

  .botInfo {
    /deep/ p {
      font-size: 14px;
      margin-bottom: 8px;

      &:nth-of-type(1) {
        color: #666;
        font-size: 14px;
      }

      &:nth-of-type(2) {
        color: black;
        font-weight: bold;
        font-size: 14px;
      }

      & > span {
        color: var(--ThemeColor);
      }
    }

    /deep/ .ant-row {
      margin-bottom: 20px;
    }
  }

  padding-bottom: 20px;
}
</style>
